import { render, staticRenderFns } from "./DetalhePedido.vue?vue&type=template&id=0a9d21fb&scoped=true"
import script from "./DetalhePedido.vue?vue&type=script&lang=js"
export * from "./DetalhePedido.vue?vue&type=script&lang=js"
import style0 from "./DetalhePedido.vue?vue&type=style&index=0&id=0a9d21fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d21fb",
  null
  
)

export default component.exports